function toPascalCase(word) {
  return word.replace(/(^|-|_|\s)(\w)/g, (match, p1, p2) => p2.toUpperCase());
}

export default function createController(event) {
  const pascalCasedWord = toPascalCase(event);

  const eventListenerName = `on${pascalCasedWord}`;
  const removeEventListenerName = `removeOn${pascalCasedWord}`;

  let registeredListeners = [];

  return {
    [event](...args) {
      registeredListeners.forEach(fn => fn(...args));
    },
    [eventListenerName](cb) {
      registeredListeners.push(cb);
    },
    [removeEventListenerName](fn) {
      registeredListeners = registeredListeners.filter(
        registeredFn => fn !== registeredFn,
      );
    },
    flush() {
      registeredListeners = [];
    },
  };
}
